const $document = $(document), 
    $header = $('.masthead__header'),
    $wrapper = $('.sticky-nav-bar'),
    $navBar = $('.sticky-nav-bar__inner'),
    classNavBarSticky = 'sticky-nav-bar--sticky';

if ($navBar.length > 0) {
    const navBarOffset = $navBar.offset().top;
    $(window).on('scroll', function () {
        scrolledDistance = $document.scrollTop();
        if (scrolledDistance >= navBarOffset) {
            $wrapper.addClass(classNavBarSticky);
        } else {
            $wrapper.removeClass(classNavBarSticky);
        }
    });
}
  